import { useMemo } from 'react';

import { DESCRIPTION_PLACEHOLDER, TITLE_PLACEHOLDER, UNIFIED_FIELD } from 'src/data/brief';
import { GENERATION_TOOL, isBasicGenerationTool } from 'src/data/generationTool';

const DEFAULT_LABELS = {
  [UNIFIED_FIELD.title]: 'Product name',
  [UNIFIED_FIELD.article]: 'Product description',
};

const DEFAULT_DD_PLACEHOLDERS = {
  [UNIFIED_FIELD.title]: TITLE_PLACEHOLDER,
  [UNIFIED_FIELD.article]: DESCRIPTION_PLACEHOLDER,
};

const DEFAULT_BASIC_PLACEHOLDERS = {
  [UNIFIED_FIELD.title]: 'Software for creating coffee.',
  [UNIFIED_FIELD.article]: 'AI for creating personalized coffee every morning that just works.',
};

const getLabel = (field) => DEFAULT_LABELS[field] || '';

const getPlaceholder = (generationTool, field) => {
  const isBasicTool = isBasicGenerationTool(generationTool);
  if (isBasicTool) {
    return DEFAULT_BASIC_PLACEHOLDERS[field] || '';
  }
  return DEFAULT_DD_PLACEHOLDERS[field] || '';
};

const getLabels = (generationTool, field) => {
  const result = {
    label: getLabel(field),
    placeholder: getPlaceholder(generationTool, field),
  };

  // We have only one exception from the usual label rules, let it be just plain condition check for now
  if (
    generationTool === GENERATION_TOOL.basicFeatureToBenefitsPractical &&
    field === UNIFIED_FIELD.article
  ) {
    result.label = 'Features';
    result.placeholder = [
      '- Remote brewing',
      '- Automatically orders beans and filters when you run out',
      '- Customize and save drink preferences',
      '- Measures and optimizes your caffeine intake',
    ].join('\n');
  }

  if (generationTool === GENERATION_TOOL.basicProductReview && field === UNIFIED_FIELD.article) {
    result.placeholder = [
      '- Mobile app lets me manage stress anywhere',
      '- Can plan meditations to fit my schedule',
      '- Helps me relax',
    ].join('\n');
  }

  if (generationTool === GENERATION_TOOL.basicProductReview && field === UNIFIED_FIELD.title) {
    result.placeholder = 'Mindful Me';
  }

  return result;
};

export const useLabels = (generationTool, field) =>
  useMemo(() => getLabels(generationTool, field), [generationTool, field]);
